import React from "react";
import {
  makeStyles,
  Box,
} from "@material-ui/core";
import LandingPageThemeSettingPanel from '../landingPageThemeSettingPanel';
import SettingTab from "../../tab/settingTab";

const style = theme => ({
  root: {
    display: "grid",
    gridTemplateColumns: "7fr 3fr",
    gridTemplateRows: "auto auto",
    columnGap: theme.spacing(2),
    gridTemplateAreas: "'panel photo'",
    [theme.breakpoints.down("md")]: {
      gridTemplateAreas: "'panel photo'"
    },
    [theme.breakpoints.down("sm")]: {
      gridTemplateAreas: "'panel panel''photo photo'"
    }
  },
  indicator: {
    border: "0.5px solid",
    borderColor: theme.palette.primary.main
  },
  scroll: {
    width: "min-content"
  }
})

const useStyles = makeStyles(style);

export default function ProductPageSettingPanelComponent() {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box gridArea="panel">
        <SettingTab />
      </Box>
      <Box gridArea={"photo"}>
        <LandingPageThemeSettingPanel />
      </Box>
    </Box>
  )
}
